module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal proposal-analytics-modal animated fadeIn",
    class: {
      'is-active': _vm.$route.path.indexOf('/analytics') > -1
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('span', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        _vm.$router.push('/a/documents')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [(_vm.documentLoaded === false) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.documentLoaded) ? _c('div', {
    staticClass: "analytics-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('document_analytics_modal.document_analytics')))]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('p', {
    staticClass: "prepared-deets"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('document_analytics_modal.prepared_for')) + ":")]), _vm._v(" " + _vm._s(_vm.document.cover.createdBy))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('document_analytics_modal.prepared_by')) + ":")]), _vm._v(" " + _vm._s(_vm.document.cover.createdFor))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "analytics-main-wrapper"
  }, [_c('div', {
    staticClass: "analytics-left-wrapper"
  }, [_c('div', {
    staticClass: "analytics-toggle"
  }, [_c('span', {
    class: {
      'active': !_vm.tab || _vm.tab === 'recipients'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'recipients'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('document_analytics_modal.recipients')))]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.tab === 'timeline'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'timeline'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('document_analytics_modal.timeline')))])]), _vm._v(" "), (_vm.tab === 'timeline') ? _c('div', {
    staticClass: "analytics-left"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('document_analytics_modal.activity')))]), _vm._v(" "), _vm._l((_vm.analytics.timeline), function(event) {
    return (_vm.analytics.timeline.length > 0) ? _c('ul', [_c('li', [_c('span', {
      staticClass: "download"
    }, [_c('i', {
      staticClass: "icon",
      class: _vm.mapClass(event.action)
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('document_analytics_modal.event', {
          viewer: event.viewer.name,
          action: event.action,
          time: event.created_at | _vm.time,
          date: event.created_at | _vm.date
        }))
      }
    })])]) : _c('p', [_vm._v(_vm._s(_vm.$t('document_analytics_modal.default_message')))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.tab === 'recipients') ? _c('div', {
    staticClass: "analytics-left"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('document_analytics_modal.recipient')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('document_analytics_modal.times_viewed')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('document_analytics_modal.total_time_spent')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('document_analytics_modal.last_viewed')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('document_analytics_modal.downloaded')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.analytics.summary), function(person, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(person.times))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(person.time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(person.last))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(person.download))]), _vm._v(" "), _c('td')])
  }))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "analytics-comments-wrapper"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('document_analytics_modal.comments')))]), _vm._v(" "), _c('div', {
    staticClass: "analytics-comments"
  }, [_c('section', {
    staticClass: "analytics-comments-body"
  }, [(_vm.comments !== false && _vm.comments.length > 0) ? _c('ul', _vm._l((_vm.comments), function(comment) {
    return _c('comment', {
      key: comment.id,
      attrs: {
        "comment": comment,
        "show-avatar": true,
        "comment-type": "full"
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "analytics-comments-foot"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCommentBody),
      expression: "newCommentBody"
    }],
    attrs: {
      "disabled": _vm.disableNewComments,
      "placeholder": _vm.$t('document_analytics_modal.comment_text_placeholder')
    },
    domProps: {
      "value": (_vm.newCommentBody)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.stopPropagation();
        _vm.submitComment($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCommentBody = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-medium is-pulled-left push-right",
    on: {
      "click": _vm.submitComment
    }
  }, [_vm._v(_vm._s(_vm.$t('document_analytics_modal.send_message')))]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-medium is-outlined is-pulled-left"
  }, [_vm._v(_vm._s(_vm.$t('document_analytics_modal.cancel')))])])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60c68bb6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/document-analytics-modal.vue
// module id = 530
// module chunks = 0